<div fxLayout>
  <main [ngClass.lt-md]="{ mobile: true }">
    <header>
      <div class="breadcrumbs" *ngIf="loading">
        <a [routerLink]="['/support-documentation']">
          <span class="icon">
            <sbnb-support-documentation-icon icon="question-mark"></sbnb-support-documentation-icon>
          </span>
          Support documentation
        </a>
      </div>
      <div class="breadcrumbs" *ngIf="!loading">
        <a [routerLink]="['/support-documentation']">
          <span class="icon">
            <sbnb-support-documentation-icon icon="question-mark"></sbnb-support-documentation-icon>
          </span>
          Support documentation
        </a>
        /
        <a [routerLink]="['/support-documentation/category', article.category.slug]">
          <span class="icon">
            <sbnb-support-documentation-icon [icon]="article.category.icon"></sbnb-support-documentation-icon>
          </span>
          {{ article.category.name }}
        </a>
        /
        <a [routerLink]="['/support-documentation/category', article.category.slug]" [fragment]="article.section.slug">
          {{ article.section.name }}
        </a>
      </div>
      <a class="close" [routerLink]="overlaySimulatorService.getCloseUrl()">
        <sbnb-support-documentation-icon icon="close"></sbnb-support-documentation-icon>
      </a>
    </header>
    <div *ngIf="loading" style="display: flex; justify-content: center; align-items: center">
      <img src="/assets/images/preloader.gif" alt="Loading..." />
    </div>
    <div class="container" *ngIf="!loading">
      <article>
        <h1>{{ article.title }}</h1>
        <p class="description" *ngIf="article.description">
          {{ article.description }}
        </p>
        <div class="author-wrapper">
          <img [src]="article.author.avatar" [alt]="article.author.name + ' avatar'" />
          <div>
            <h4 class="author">{{ article.author.name }}</h4>
            <div class="last-updated">Updated {{ article.updated_at | timeAgo }}</div>
          </div>
        </div>
        <section [innerHTML]="article.body | safe: 'html'"></section>
      </article>
      <section class="related-articles">
        <sbnb-article-list
          title="Related articles"
          [articles]="article.related_articles"
          columns="2"></sbnb-article-list>
      </section>
      <section class="feedback" *ngIf="feedbackState === 'question'">
        <div class="primary-text flex-1">Did you find an answer to your question?</div>
        <button class="button yes" (click)="sendFeedback('positive')" [disabled]="feedbackLoading ? 'disabled' : ''">
          Yes
        </button>
        <button class="button no" (click)="sendFeedback('negative')" [disabled]="feedbackLoading ? 'disabled' : ''">
          No
        </button>
      </section>
      <section class="feedback" *ngIf="feedbackState === 'positive'">
        <div class="primary-text">😇 Happy to hear that!</div>
        <div class="secondary-text">Feel free to reach out to us if your have further questions.</div>
      </section>
      <section class="feedback" *ngIf="feedbackState === 'negative'">
        <div class="primary-text">😓 Sorry to hear that.</div>
        <div class="secondary-text">Please check other articles or get in touch with our support team.</div>
      </section>
    </div>
  </main>
</div>
